import { render, staticRenderFns } from "./ManageUsersHead.vue?vue&type=template&id=6d60312d&scoped=true"
import script from "./ManageUsersHead.vue?vue&type=script&lang=js"
export * from "./ManageUsersHead.vue?vue&type=script&lang=js"
import style0 from "./ManageUsersHead.vue?vue&type=style&index=0&id=6d60312d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d60312d",
  null
  
)

export default component.exports